// @flow

const findIsPrimary = (items: Array<{ isPrimary: boolean }>) => {
  const primary = items.find((item) => item.isPrimary);
  return primary || items[0];
};

export default findIsPrimary;
